import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
  align-items: center;
  
  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(14)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  shadow-color: #000;
  shadow-opacity: 0.04;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 1;
`;

export const StoreInfos = styled.View`
  margin-left: ${RFValue(12)}px;
  
`;
